import React, {Component} from 'react'
import { Link } from 'react-router-dom'

import firebase from '../Configs/firebase'
import List from './_List'


class MapsUserMenu extends Component{
    constructor(props){
        super(props)
        this.state = {
            isShow2ndList:false,
            email:'',
            password:'',
            mode:null,
            owner:null
        }

        this.handleClose = this.handleClose.bind(this)
        this.handleShow1stMenu = this.handleShow1stMenu.bind(this)
        this.handleLogout = this.handleLogout.bind(this)
        this.handleSelectedMenu = this.handleSelectedMenu.bind(this)
        this.handleOpenFeedback = this.handleOpenFeedback.bind(this)
        // this.handleDownload = this.handleDownload.bind(this)
    }

    handleClose(){
        this.props.setShowMenu(false)
    }
    
    handleLogout(){
        firebase.auth().signOut()
    }

    handleSelectedMenu(e,index){
        if(index === 0){
            this.setState({
                mode:'plan',
                owner:'my'
            })
        } else if ( index === 1) {
            this.setState({
                mode:'plan',
                owner:'other'
            })
        } else if ( index === 2 ) {
            this.setState({
                mode:'drone',
                owner:'my'
            })
        } else if ( index === 3 ) {
            this.setState({
                mode:'drone',
                owner:'other'
            })
        }
        this.setState({isShow2ndList:true})
    }

    handleShow1stMenu(){
        this.setState({isShow2ndList:false})
    }

    handleOpenFeedback(){
        const { setIsOpenHelpAndFeedback } = this.props
        setIsOpenHelpAndFeedback(true)
    }

    // handleDownload(){
    //     window.open('http://l.ead.me/Ling')
    // }

    render(){
        const { isShow2ndList, mode, owner } = this.state
        const { user } = this.props

        var listOutput = null
        var listMenu =  <div>
                            <div className="is-div-menu" onClick={(e)=>this.handleSelectedMenu(e,0)}>
                                <img src="/Images/my_plan@3x.png" alt="My plan" width="20" height="20"/>
                                <label className="is-text-menu"> แปลงของฉัน</label>
                            </div>
                            <div className="is-div-menu" onClick={(e)=>this.handleSelectedMenu(e,2)}>
                                <img src="/Images/drone_data@3x.png" alt="My drone" width="20" height="20"/>
                                <label className="is-text-menu"> ข้อมูลของฉัน</label>
                            </div><hr/>
                            <div className="is-div-menu" onClick={(e)=>this.handleSelectedMenu(e,1)}>
                                <img src="/Images/saved_plan@3x.png" alt="Saved plan" width="20" height="20"/>
                                <label className="is-text-menu"> โปรเจคที่ติดตาม</label>
                            </div>
                            <div className="is-div-menu" onClick={(e)=>this.handleSelectedMenu(e,3)}>
                                <img src="/Images/saved_drone_data@3x.png" alt="Saved drone" width="20" height="20"/>
                                <label className="is-text-menu"> ข้อมูลจากเพื่อน</label>
                            </div><hr/>
                        </div>
        if(user === null || user === undefined ){
            listOutput =    <div className="UserMenu">
                                <div className="box">
                                    <div className="ListHeader">
                                        <span onClick={this.handleClose} className="CloseMenu"><i className="fas fa-times"></i></span>
                                    </div>
                                    <Link to="/login" className="button is-primary is-max-width">เข้าสู่ระบบ</Link>
                                </div>
                            </div>
        } else if(isShow2ndList === false ){
            listOutput =    <div className="UserMenu">
                                <div className="box">
                                    <div className="ListHeader">
                                        <span onClick={this.handleClose} className="CloseMenu"><i className="fas fa-times"></i></span>
                                    </div>
                                    {listMenu}
                                    <div className="is-center">
                                        <iframe title="introduction" width="320" height="148" src="https://www.youtube.com/embed/hrIZm49gcGw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                    </div>
                                    <div className="is-center is-qr">
                                        <img src="/Images/qr_code.png" alt="Appstore" height="200px" width="200px"></img>
                                    </div>
                                    <div className="is-center">
                                        {/* <div role="button" onClick={this.handleDownload} className="is-a-white">Download</div> */}
                                        <a href="http://l.ead.me/Ling" className="is-a-white">Download</a>
                                    </div>
                                    <br/>
                                    <div className="is-footer-menu">
                                        <div onClick={this.handleOpenFeedback} className="is-a-white">Help & feedback</div>
                                    </div>
                                </div>
                            </div>
        } else if(isShow2ndList === true ){
            listOutput =    <List mode={mode} owner={owner} handleClose={this.handleClose} handleShow1stMenu={this.handleShow1stMenu}/>
        }
        return(
            <div >
                {listOutput}
            </div>
        )
    }
}

export default MapsUserMenu


// WEBPACK FOOTER //
// ./src/PageMaps/_MapsUserMenu.js